import React from 'react'
import { Redirect } from 'react-router-dom'
import globalConfig from 'app/fuse-configs/globalConfig'

const GroupsConfig = {
	settings: {
		layout: {
			config: {
				...globalConfig
			}
		}
	},
	auth: [1],
	routes: [
		{
			path: ['/user/groups/group/:groupId?'],
			component: React.lazy(() => import('./GroupsApp'))
		},
		{
			path: '/user/groups',
			component: () => <Redirect to="/user/groups/group/all" />
		}
	]
}

export default GroupsConfig
